
'use client';

import * as React from 'react';
import { useRouter } from 'next/navigation';
import { SearchModule } from '@/components/job-search/search-module';
import type { SearchFilters } from '@/components/job-search/search-results';
import { JobCarousel } from '@/components/job-carousel';

const JOB_SEARC_LINKS: any = [
    {
        "title": "👍Quay lại lương cao",
        "key": "quay-lai-luong-cao",
        "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=dac-dinh-dau-viet&luong-co-ban=250000&showExpired=false"
    },
    {
        "title": "💰Chuyển việc lương cao",
        "key": "chuyen-viec-luong-cao",
        "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=dac-dinh-dau-nhat&luong-co-ban=250000&showExpired=false"
    },
    {
        "title": "🔥Lương cao cho người mới",
        "key": "luong-cao-cho-nguoi-moi",
        "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=thuc-tap-sinh-3-nam&luong-co-ban=200000&showExpired=false"
    },
    {
        key: 'super-hot',
        childrens: [
            {
                "title": "⭐Ngành nghề siêu HOT",
                "key": "thuc-pham-dau-nhat",
                "tooltip": <>Những ngành nghề đang có nhu cầu tuyển dụng cao tại Nhật, nhiều đơn hàng, cơ hội việc làm ổn định và khả năng tăng ca tốt. Phù hợp với người lao động muốn dễ trúng tuyển và có thu nhập ổn định.<i>Tùy từng đơn hàng, mức lương và điều kiện làm việc có thể khác nhau.</i></>,
                "searchLink": "/tim-viec-lam?q=Thực+phẩm%3BCơ+khí%3BHàn%3BTiện%3BĐiện+tử%3BÔ+tô%3BNông+nghiệp%3BTrồng+trọt%3BChăn+nuôi&chi-tiet-loai-hinh-visa=dac-dinh-dau-viet&dia-diem=Tokyo&dia-diem=Osaka&dia-diem=Aichi&dia-diem=Kanagawa&dia-diem=Fukuoka&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
            {
                "title": "🥇Vùng tỉnh HOT",
                "key": "vung-tinh-hot",
                "tooltip": <>Các tỉnh/thành phố sầm uất, đông dân cư, nhiều khu vui chơi – giải trí và cơ hội việc làm. Phù hợp với người thích môi trường năng động, tiện nghi và dễ hòa nhập cuộc sống tại Nhật.<br /><i>Lưu ý: Chi phí sinh hoạt tại khu vực HOT có thể cao hơn các vùng khác.</i></>,
                "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=dac-dinh-dau-viet&dia-diem=Tokyo&dia-diem=Osaka&dia-diem=Aichi&dia-diem=Kanagawa&dia-diem=Fukuoka&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
        ]
    },
    {
        "key": 'dac-dinh',
        "childrens": [
            {
                "title": "Đặc định đầu Việt",
                "key": "dac-dinh-dau-viet",
                "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=dac-dinh-dau-viet&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
            {
                "title": "Đặc định đầu Nhật",
                "key": "dac-dinh-dau-nhat",
                "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=dac-dinh-dau-nhat&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
        ]
    },
    {
        "title": "Thực tập sinh 3 năm",
        "key": "thuc-tap-sinh-3-nam",
        "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=thuc-tap-sinh-3-nam&showExpired=false",
    },
    {
        "key": 'ky-su-tri-thuc',
        "childrens": [
            {
                "title": "Kỹ sư, tri thức đầu Việt",
                "key": "ky-su-tri-thuc-dau-viet",
                "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=ky-su-tri-thuc-dau-viet&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
            {
                "title": "Kỹ sư, tri thức đầu Nhật",
                "key": "ky-su-tri-thuc-dau-nhat",
                "searchLink": "/tim-viec-lam?chi-tiet-loai-hinh-visa=ky-su-tri-thuc-dau-nhat&showExpired=false",
                basisClass: 'basis-[80%] sm:basis-1/2 lg:basis-1/2'
            },
        ]
    },
    {
        "title": "Có thể bạn quan tâm",
        "key": "co-the-ban-quan-tam",
        "searchLink": "/tim-viec-lam?showExpired=false"
    }
];

export default function ViecLamPage() {
    const router = useRouter();

    const handleNewSearch = React.useCallback((filters: Partial<SearchFilters>) => {
        const query = new URLSearchParams();
        if (!!filters.visaDetail && filters.visaDetail != '' && filters.visaDetail != 'all') {
            query.set('chi-tiet-loai-hinh-visa', filters.visaDetail || '');
        }
        if (!!filters.career && filters.career != '' && filters.career != 'all') {
            query.set('nganh-nghe', filters.career || '');
        }
        if (!!filters.workLocation && !!filters.workLocation?.length) {
            filters.workLocation.forEach(loc => {
                if (!!loc?.length) {
                    query.append('dia-diem', loc || '');
                }
            })
        }
        router.push(`/tim-viec-lam?${query.toString()}`);
        // Thực hiện logic tìm kiếm ở đây
    }, []);
    return (
        <div className="flex flex-col items-center min-h-screen">
            <SearchModule
                onSearch={handleNewSearch}
                filters={{}}
                onFilterChange={() => { }}
                showHero={false}
            />
            <div className="w-full flex-grow container mx-auto px-4 md:px-6 py-8">
                {JOB_SEARC_LINKS.map((group: any) => {
                    if (!!group.childrens) {
                        return <div key={group.key} className={`grid grid-cols-1 md:grid-cols-${group.childrens.length} gap-4`}>
                            {
                                group.childrens.map((child: any) => {
                                    return <JobCarousel
                                        key={child.key}
                                        data={child}
                                    />
                                })
                            }
                        </div>
                    } else {
                        return <JobCarousel
                            key={group.key}
                            data={group}
                        />
                    }
                })}
            </div>
        </div>
    );
}
